<template>
  <title-tab
    :msg="lottoName"
    :img-src="lottoImg"
    :had-data="hadData"
    :msg-append="!Isclosed && Isnotmobile ? startTime : null"
  >
    <template
      v-if="hadData && false"
      v-slot:extensionBottom
    >
      <v-tabs
        v-if="!Isclosed"
        v-model="currentItem"
        class="toolbartab"
        background-color="var(--bg-main-color)"
        slider-color="white"
        show-arrows="show-arrows"
      >
        <v-tab
          v-if="is_player_make_result&&!Isclosed"
          @click="selectTabItem(0,1)"
        >
          <h4>{{ $t('button.add-number') }}</h4>
        </v-tab>
        <v-row v-if="!Islocked">
          <v-tab
            v-for="item in halfArraylength(fliterbyDigit(2))"
            :key="1.21+item"
            @click="selectTabItem(2,item)"
          >
            <h4>{{ $t('lotto-type.two') }}</h4>
          </v-tab>
          <v-tab
            v-for="item in halfArraylength(fliterbyDigit(3))"
            :key="1.31+item"
            @click="selectTabItem(3,item)"
          >
            <h4>
              <v-row v-if="item&lt;=1">
                {{ $t('lotto-type.three') }}
              </v-row>
              <v-row v-else>
                <div>{{ fliterbyDigit(3)[2*(item-1)].number_type.name }}</div>
                <div v-if="fliterbyDigit(3)[2*(item-1)+1]">
                  +{{ fliterbyDigit(3)[2*(item-1)+1].number_type.name }}
                </div>
              </v-row>
            </h4>
          </v-tab>
          <v-tab
            v-for="(item,index) in fliterbyDigit(4)"
            :key="1.41+index"
            @click="selectTabItem(4,index)"
          >
            <h4>{{ item.number_type.name }}</h4>
          </v-tab>
          <v-tab
            v-for="item in halfArraylength(fliterbyDigit(1))"
            :key="1.51+item"
            @click="selectTabItem(1,item)"
          >
            <h4>{{ $t('run-number') }}</h4>
          </v-tab>
          <v-tab @click="selectTabWin()">
            <h4>{{ $t('win_number') }}</h4>
          </v-tab>
        </v-row>
      </v-tabs>
      <v-tabs
        v-else
        v-model="currentItem"
        class="toolbartab"
        background-color="var(--bg-main-color)"
        slider-color="white"
        no-animation="no-animation"
      >
        <v-tab>
          <h4>{{ $t('prize') }}</h4>
        </v-tab>
      </v-tabs>
    </template>
    <template #buttonAppend>
      <v-btn
        class="mr-2"
        dark="dark"
        outlined="outlined"
        small="small"
        @click="openRule"
      >
        <v-img src="@/assets/lottery/icon-note.svg"></v-img>{{ $t('button.lotto-rules') }}
      </v-btn>
      <v-btn
        v-if="nextGameId"
        small="small"
        outlined="outlined"
        @click="nextRound"
      >
        {{ $t('button.next-round') }}
      </v-btn>
    </template>
    <template #bottomAppend>
      <v-row
        v-if="!Isclosed&&(currentItem!==0 || !is_player_make_result)"
        class="px-3 pb-3"
        no-gutters="no-gutters"
        justify="space-between"
      >
        <!-- <v-col
          class="mt-3"
          cols="12"
          md="10"
          align="start"
        >
          <v-row
            class="pa-1"
            no-gutters="no-gutters"
          >
            <v-col> 
              <v-btn-toggle
                class="ml-2"
                :value="switchStatus"
                light="light"
                color="red"
                @input="switchNumber = $event === 0"
              >
                <v-btn
                  small="small"
                  @click="switchNumberToggle"
                >
                  <v-icon>mdi-swap-horizontal</v-icon>
                  <h4>{{ $t('button.reverse') }} </h4>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
    </template>
    <menu-mode
      v-if="is_player_make_result && !Isclosed && !Islocked"
      class="mt-2"
      :current-mode="currentMode"
      @change="onModeChange"
    ></menu-mode>

    <component
      :is="currentView"
      v-if="is_player_make_result && !Isclosed && !Islocked && currentMode == MODE_ADD"
      :index-select="indexSelect"
      :switch-toggle="switchNumber"
      :game-type="gameType"
      :rule-lotto="ruleMessage"
      :lotto-name="lottoName"
      :first-tab="firstTab"
      :second-tab="secondTab"
      :win-tabs="winTabs"
      :user-select="userSelect"
      :filter-number="filterNumber"
      :countdown-sent="startTime"
      :close-time="closeTime"
      :closed-timestamp="closed_timestamp"
      :limit-conditions="limit_conditions"
      :voucher="voucher"
      @removeLastNumber="removeLastNumber"
      @changeStatus="changeStatus"
      @clearAll="clearAll"
      @addValue="addValue"
      @delValue="delValue"
    ></component>
   
    <div
      v-if="hadData && currentMode == MODE_PLAY"
      class="flex gap-2 all-layout"
    >
      <div
        v-if="!Isclosed && !Islocked"
        class="w-full result-price mt-3"
      >
        <button
          id="poi-save-dialog-btn"
          class="mb-2 w-full"
          type="button"
          @click="openPullPoll"
        >
          <div class="flex items-center justify-center font-bold">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
              class="mr-1"
            ><path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
            ></path></svg> ดึงโพย
          </div>
        </button>
        <result-price
          v-if="Isnotmobile"
          class="w-full result-price mt-1"
          :user-select="userSelect"
          :number-conditions="numberConditionsUpdate"
          :voucher="voucher"
          @removeSameNumber="removeSameNumber"
          @clearAll="clearAll"
          @delValue="delValue"
          @load="load"
          @confirm="open_confirm = true"
        ></result-price>
        <result-footer
          v-if="!Isnotmobile"
          :user-select="userSelect"
          @confirm="open_confirm = true"
        ></result-footer>
      </div>

      <div class="flex flex-col mt-3 w-full gap-2">
        <main-menu
          v-if="!Isclosed && !Islocked"
          :current-menu="currentMenu"
          :show-add-number="is_player_make_result"
          @change="onMenuChange"
        ></main-menu>

        <component
          :is="currentView"
          :index-select="indexSelect"
          :switch-toggle="switchNumber"
          :game-type="gameType"
          :rule-lotto="ruleMessage"
          :lotto-name="lottoName"
          :first-tab="firstTab"
          :second-tab="secondTab"
          :win-tabs="winTabs"
          :user-select="userSelect"
          :filter-number="filterNumber"
          :countdown-sent="startTime"
          :close-time="closeTime"
          :closed-timestamp="closed_timestamp"
          :limit-conditions="limit_conditions"
          :voucher="voucher"
          @removeLastNumber="removeLastNumber"
          @changeStatus="changeStatus"
          @clearAll="clearAll"
          @addValue="addValue"
          @delValue="delValue"
        >
          <!-- <result-price
            v-if="Isnotmobile"
            :user-select="userSelect"
            :number-conditions="numberConditionsUpdate"
            :voucher="voucher"
            @removeSameNumber="removeSameNumber"
            @clearAll="clearAll"
            @delValue="delValue"
            @load="load"
          ></result-price> -->
        </component>
      </div>
    </div>
    <!-- v-if="!Isnotmobile && !Isclosed && !Islocked" -->
    <!-- <mobile-footer
      v-if="true"
      ref="mobileFooter"
      :user-select="userSelect"
      :number-conditions="numberConditionsUpdate"
      :voucher="voucher"
      @removeSameNumber="removeSameNumber"
      @clearAll="clearAll"
      @delValue="delValue"
      @addItemFromDialog="addItemFromDialog"
      @switchNumberToggle="switchNumberToggle"
      @load="load"
    >
    </mobile-footer> -->
    <dialog-rule-lotto
      ref="DialogRuleLotto"
      :message="ruleMessage"
    ></dialog-rule-lotto>
    <dialog-voucher
      ref="DialogVoucherRef"
      @addvoucher="addVoucher"
    ></dialog-voucher>
    <dialog-gropnumber-pullpoll
      ref="pullpollRef"
      @addItemFromDialog="addItemFromDialog"
    ></dialog-gropnumber-pullpoll>
    <dialog-confirm 
      v-if="open_confirm"
      :number-conditions="numberConditionsUpdate"
      :user-select="userSelect"
      :voucher="voucher"
      @clearAll="clearAll"
      @delValue="delValue"
      @close="open_confirm = false"
    >
    </dialog-confirm>
  </title-tab>
</template> 
<script>
import { getTime, timeRemain, timeStampConvert } from '@/plugins/time' 
import { imagePath } from '@/plugins/mapImage' 
import * as c from '@/const/setTimeOutConfig'  
import { IsGameCanUserVoucher } from '@/const/gameId'
import { 
  ROUTE_GAME_LOTTO_DETAIL, 
  ROUTE_INTERNAL_LOTTO 
} from '@/const/route'
import { gameRooms as apiGameRooms } from '@/apis' 
import resultaftertimeout from './childs/P00ResultAfterTimeOut.vue'
import addnumber from './childs/P01AddNumber'
import twodigit from './childs/P02TwoDigit'
import threedigit from './childs/P03ThreeDigit' 
import fourdigit from './childs/P04FourDigit'
import onedigit from './childs/P05OneDigit' 
import winDigit from './childs/P06WinDigit'
import manualDigitInput from './childs/P07ManualInput'
import selectPanekInput from './childs/P08SelectPanelInput'
import MainMenu from './childs/MainMenu'
import MenuMode from './childs/MenuMode'
import ResultPrice from './childs/ResultPriceCard/WebResultPriceCard/index'
import MobileFooter from './childs/ResultPriceCard/MobileResultPriceCard/index'
import DialogGropnumberPullpoll from '@/components/Dialog/DialogGropnumberPullpoll'
import DialogRuleLotto from '@/components/Dialog/DialogLottoRule' 
import DialogVoucher from '@/components/Dialog/DialogVoucher'
import DialogConfirm from './childs/DialogConfirm'
import ResultFooter from './childs/ResultFooter'

const WIN_NUMBER = -1
const MANUAL_DIGIT_INPUT = -2
const SELECT_PANEL_INPUT = -3

const MENU_ADD_NUMBER = 'addnumber'
const MENU_MANUAL = 'manual'
const MENU_SELECT = 'select'
const MENU_WIN = 'win'

const MODE_ADD = 'add'
const MODE_PLAY = 'play'

const DEFAULT = () => ({ 
  open_confirm: false,
  currentItem : 0,   
  switchNumber : false, 
  hadData : false,
  digitSelect : MANUAL_DIGIT_INPUT,
  indexSelect : 0,
  is_player_make_result : false, 

  startTime : '',
  closeTime : '',
  locked_timestamp : 0,
  closed_timestamp : 0,
  Islocked :true,
  Isclosed :false,  

  voucher :{},
  userSelect : [], 
  numberConditionsUpdate: [],
  number_conditions : [],
  limit_conditions : [],
  filterNumber : '',  
  gameType : {},
  stacked:null,

  lottoName : null,
  lottoImg : null,
  ruleMessage : '',

  currentMenu: MENU_MANUAL,
  currentMode: MODE_PLAY,
})
export default {
  components:{ 
    DialogRuleLotto,
    DialogGropnumberPullpoll,
    DialogVoucher,
    ResultPrice,
    addnumber,
    twodigit,
    threedigit, 
    fourdigit,
    onedigit,
    winDigit,
    resultaftertimeout,
    MobileFooter,
    MainMenu,
    manualDigitInput,
    selectPanekInput,
    DialogConfirm,
    ResultFooter,
    MenuMode,
  },
  data: () => DEFAULT(),
  computed : {
    MODE_ADD: () => MODE_ADD,
    MODE_PLAY: () => MODE_PLAY,
    yeekeeBackUp () { 
      return localStorage.getItem('yeekeeRound') || []
    },

    nextGameId () {
      let yeekeeBackUp = JSON.parse(this.yeekeeBackUp)
      let game_rounds_same_type = (yeekeeBackUp.find(x=>x.id === this.gameType.id) || {}).game_rounds
      //prevent cannot undefined value && not approved 1 round
      if(!game_rounds_same_type || game_rounds_same_type.length <= 1){
        return null
      }
      
      let index = game_rounds_same_type.findIndex(x=>x.round_rooms[0].uuid === this.gameId)
      index = index > 0 ? index :0
      let nextIndex = index+1 >= game_rounds_same_type.length ? 0 : index+1 
      return ((game_rounds_same_type[nextIndex] || {}).round_rooms[0] || {}).uuid || null
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },

    userRoleId () {
      return (this.userProfile.role || {}).id
    },

    switchStatus () {
      return this.switchNumber ? 0 : null
    },

    firstTab () {
      let index = this.IsOneTab(this.digitSelect) ? this.indexSelect : this.indexSelect * 2
      return this.numberConditionsUpdate.filter(x=>x.number_type.digit===this.digitSelect)[index]
    },

    secondTab () {
      let result = this.numberConditionsUpdate.filter(x=>x.number_type.digit===this.digitSelect)[(2*this.indexSelect)+1] 
      return result ? result : false
    },

    isWinTab () {
      return this.digitSelect == WIN_NUMBER
    },

    winTabs () {
      let mainDigit = []

      switch (this.digitSelect) {
        case WIN_NUMBER:
          mainDigit = [4, 3, 2]
          break
        default:
          mainDigit = [4, 3, 2, 1]
          break
      }

      return this.numberConditionsUpdate.filter((x) => mainDigit.includes(x.number_type.digit)).sort((a, b) => b.number_type.digit - a.number_type.digit)
    },

    Isnotmobile () {
      return this.$vuetify.breakpoint.mdAndUp
    },
    
    currentView () { 
      if(this.Isclosed) return 'resultaftertimeout' 
      if(this.Islocked && this.is_player_make_result) return 'resultaftertimeout'
      switch (this.digitSelect) {
        case 0 : 
          return 'addnumber'
        case 1:
          return 'onedigit'
        case 2:
          return 'twodigit'
        case 3:
          return 'threedigit'
        case 4:
          return 'fourdigit'
        case -1:
          return 'winDigit'
        case -2:
          return 'manualDigitInput'
        case -3:
          return 'selectPanekInput'
      }
      return 'resultaftertimeout'
    },

    gameId (){
      return this.$route.query.id
    }
  }, 

  watch: {
    async gameId () {
      this.reset()
      await this.load()
    },
    async voucher () { 
      await this.initUserPricePerCondition()
      if(!this.voucher.rules) {
        return
      }
      let specialNumberConditionType = this.number_conditions.find(x=>x.number_type.id === this.voucher.rules.number_type.id)
      this.numberConditionsUpdate = this.voucher.uuid ? [specialNumberConditionType] : this.number_conditions
    },
  },

  async mounted () {     
    await this.load()
  }, 
  
  methods : {
    reset () {
      Object.assign(this.$data, DEFAULT()) 
    },
    nextRound () {  
      this.$router.push({ 
        name: ROUTE_GAME_LOTTO_DETAIL, 
        query: { id: this.nextGameId } 
      }).catch(()=>{});   
      // this.load()
    },
    async load () {   
      if(!this.gameId) {
        this.$router.push({name:ROUTE_INTERNAL_LOTTO})
        return
      }
      
      this.hadData = false  
      this.switchNumber = false
      this.number_conditions = []
      this.limit_conditions = []
      this.voucher = {}
      this.clearAll()
      const [err,data] = await apiGameRooms.getRoomById(this.gameId)
      
      this.$nextTick(()=>this.hadData = true)   

      if(err) {
        this.$alert('',err,'warning')
        return 
      }
       
      this.ruleMessage = data.game.detail
      this.lottoName = data.name  
      this.lottoImg = imagePath(data.game_id, data.name)  
      this.is_player_make_result = data.is_player_make_result

      if (this.is_player_make_result) {
        this.digitSelect = 0
        this.currentMenu = MENU_ADD_NUMBER
        this.currentMode = MODE_ADD
      }

      this.locked_timestamp= timeStampConvert(data.locked_at)
      this.closed_timestamp = (timeStampConvert(data.closed_at)-c.CLOSEGAMEBEFORE ) //close before 5 second 

      this.gameType = data.game_type
      this.number_conditions = data.number_conditions
      this.numberConditionsUpdate = data.number_conditions
      this.limit_conditions = data.limit_conditions
      this.stacked = data.stacked

      await this.initUserPricePerCondition()
      await this.initCheckFirstTab()
      await this.initCheckTime()   
      //set default tab init here 
      this.currentItem = 0

      if (this.Isclosed || this.Islocked) {
        this.currentMode = MODE_PLAY
      }

      //open and call api voucher
      if(IsGameCanUserVoucher(data.game_type.id)){ 
        this.$nextTick(()=>{  
          if(this.$refs.DialogVoucherRef) {
            this.$refs.DialogVoucherRef.open() 
          }
        })
      } 
    }, 

    async initUserPricePerCondition () {
      this.number_conditions.forEach(
        arrayDigit =>{
          arrayDigit.status = false
          arrayDigit.userReward = this.checkUserPrice(arrayDigit) 
          arrayDigit.limit_conditions = this.limit_conditions.length === 0 ? [] :
          this.limit_conditions.filter(x=>((x.number_type.id===arrayDigit.number_type.id) && x.quota_unit_remain<=0))   
        }
      );   
    },

    addVoucher (item) {    
      this.voucher = item  
    },

    IsOneTab (digit) {
      return [4].includes(digit)
    },

    selectTabItem (digit,index) {
      this.digitSelect = digit 
      this.indexSelect = this.IsOneTab(digit) ? index : index-1
    },

    selectTabWin () {
      this.digitSelect = -1
      // this.indexSelect = 3
    },


    async initCheckFirstTab () {  
      // this.digitSelect = this.is_player_make_result ?  0 :
      // this.numberConditionsUpdate.find(x=>x.number_type.digit === 2) ? 2 :
      // this.numberConditionsUpdate.length!==0 ? this.numberConditionsUpdate[0].number_type.digit : ''
    },
    
    async initCheckTime () { 
      if(timeRemain(this.locked_timestamp)>0 && this.$route.name === ROUTE_GAME_LOTTO_DETAIL ) { 
        this.Islocked = false 
        this.Isclosed = false
        this.startTime = getTime (timeRemain(this.locked_timestamp)) 
        this.countDownTimer() 
      } else {
        this.startTime = this.$t('closed-stake')
        this.Islocked = true
        if(timeRemain(this.closed_timestamp) >0 && this.$route.name === ROUTE_GAME_LOTTO_DETAIL ) {    
          this.Isclosed = false   
          this.closeTime = getTime (timeRemain(this.closed_timestamp)) 
          this.countDownCloseTimer() 
        } else {
          this.closeTime = this.$t('closed-prediction')
          this.Isclosed = true
        }  
      } 
    },

    halfArraylength (array) {  
      return Math.round(array.length/2)
    }, 

    fliterbyDigit (digit) { 
      return this.numberConditionsUpdate.filter(x=>x.number_type.digit===digit) 
    }, 

    // slow sup sup
    addItemFromDialog (item){ 
      item.forEach(element=>{   
        let conditionsResult = this.numberConditionsUpdate.find(
          x=>x.number_type.id===element.number_type.id
        )
        //check type inside number condition
        if(conditionsResult){ 
          let limitResult = this.limit_conditions.filter(
            x=>(
              (x.number_type.id===element.number_type.id) 
              && x.quota_unit_remain<=0 
              && x.number === element.number))   
          //not add inside the result list
          // if(limitResult.length!==0) {
          //   return
          // }

          let price = limitResult.length!==0 ? Math.min.apply(Math,limitResult.map(x=>x.quota_reward)) : conditionsResult.userReward 
          
          //check used voucher and replace by rule
          if(this.voucher.rules) {
            let { number_type, stake_max_number } = this.voucher.rules
            // break when not right on rule
            if(number_type.id !== element.number_type.id || this.userSelect.length >= stake_max_number ) {
              return
            } 

          }

          this.addValue(price,element.number,element.number_type.id)  
          this.changeStatus(element.number_type.id,true)
        }
      }) 
      if(!this.Isnotmobile){
        this.$refs.mobileFooter.viewBet() 
      }
    }, 

    async addValue (price,value,id,Nineteen,FrontRoot,BackRoot) { 
      this.userSelect.push({ 
        userReward : price,
        number : value,
        number_type_id : id,
        unit : 1,
        selectNineteen : Nineteen,
        selectFrontRoot : FrontRoot,
        selectBackRoot : BackRoot,
      })  
    },

    delValue (_,value,id,selectNineteen,selectFrontRoot,selectBackRoot ) {
      if (this.userSelect.length!==0){ 
        this.userSelect.every((element,index)=>{
          if (element.number===value && element.number_type_id===id 
          && element.selectNineteen === selectNineteen && element.selectFrontRoot === selectFrontRoot
          && element.selectBackRoot === selectBackRoot 
          ) {
            this.userSelect.splice(index,1)  
            return false
          }else {
            return true
          }
        })
      } 
    }, 

    changeStatus (id,status) {   
      var index = this.number_conditions.findIndex(x=>x.number_type.id===id)
      this.number_conditions[index].status = 
      typeof(status)==="boolean" ? status : 
      !this.number_conditions[index].status 
    },

    removeLastNumber () {  
      var i = 0

      if(this.userSelect.length === 0) {
        return
      }
      
      var element =  this.userSelect[this.userSelect.length-1] 
      var amountloop = element.selectNineteen ? 19 : element.selectFrontRoot || element.selectBackRoot ? 10 : 1  
      while(i<amountloop&&this.userSelect.length!==0){ 
        this.userSelect.splice(this.userSelect.length-1,1)  
        i++
      }   
    },  

    clearAll () { 
      this.userSelect = []       
    },

    removeSameNumber () {   
      var result = []
      this.number_conditions.forEach(element=>{ 
          result.push(...new Map(this.userSelect.filter(e=>e.number_type_id===element.number_type.id)
          .map(item => [item.number, item])).values()) 
      }) 
      this.userSelect = result 
    },

    checkUserPrice (element) { 
      let reward = parseFloat(element.reward)
      //plus stcked extra First
      if(this.stacked && this.stacked.extra_reward) {
        // var x (100+percent)/100 = var + (var x percent)/100
        reward *= (100+ parseFloat(this.stacked.extra_reward))/100 //short formular
      }
      //multiply if ahd voucher Second
      if(this.voucher.amount) {
        reward *= this.voucher.amount
      }
      switch(this.userRoleId){
        case 1:
          return reward  
        case 2:
          return reward + element.vip1_add_on
        case 3:
          return reward + element.vip2_add_on 
        case 4:
          return reward + element.vip3_add_on 
        case 5:
          return reward + element.vip4_add_on  
        default:
          return reward
      }
    },

    onMenuChange (menu) {
      this.currentMenu = menu

      switch (menu) {
        case MENU_WIN:
          this.digitSelect = WIN_NUMBER
          break
        case MENU_MANUAL:
          this.digitSelect = MANUAL_DIGIT_INPUT
          break
        case MENU_SELECT:
          this.digitSelect = SELECT_PANEL_INPUT
          break
        case MENU_ADD_NUMBER:
          this.digitSelect = 0
          break
      }
    },

    onModeChange (mode) {
      this.currentMode = mode

      switch (mode) {
        case MODE_PLAY:
          this.digitSelect = MANUAL_DIGIT_INPUT
          this.currentMenu = MENU_MANUAL
          break
        case MODE_ADD:
          this.digitSelect = 0
          break
      }
    },
    
    switchNumberToggle (){ 
      this.$ga.event('Button', 'ToggleSwitchNumber', 'GamePage', '')
      this.switchNumber =! this.switchNumber
    },
    
    openRule () {
      this.$ga.event('Button', 'GameRule', 'GamePage', '')
      this.$refs.DialogRuleLotto.open()
    }, 

    countDownTimer () {  
      setTimeout(() => {
        if(timeRemain(this.locked_timestamp)>0 && this.$route.name === ROUTE_GAME_LOTTO_DETAIL ) { 
          this.startTime = getTime (timeRemain(this.locked_timestamp))  
          this.countDownTimer() 
        }else {
          this.startTime = this.$t('closed-stake')
          this.Islocked = true
          this.countDownCloseTimer ()
        } 
      }, c.COUNTDOWNONESEC)
    }, 

    countDownCloseTimer () {    
      setTimeout(() => {
        if(timeRemain(this.closed_timestamp) >0 && this.$route.name === ROUTE_GAME_LOTTO_DETAIL ) {    
          this.closeTime = getTime (timeRemain(this.closed_timestamp)) 
          this.countDownCloseTimer() 
        } else {
          this.closeTime = this.$t('closed-prediction')
          this.Isclosed = true
        } 
      }, c.COUNTDOWNONESEC)
    },

    openPullPoll () {
      this.$refs.pullpollRef.open()
    }
  }
}
</script> 
<style scoped> 
.v-tab {
  min-width: 60px !important;
}

.result-price {
  max-width: 14rem;
}

@media only screen and (max-width: 960px) {  
  .result-price {
    max-width: unset;
  }

  .all-layout {
    flex-direction: column;
  }
} 

svg {
  height: 1.25rem;
  width: 1.25rem;
}

#poi-save-dialog-btn {
  background-color: var( --bg-secondary-color-v2);
  color: #000;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: rgba(var(--color-primary));
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn:hover, [type=button]:hover, [type=submit]:hover, button:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  filter: brightness(.9);
}
</style>